import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Grid, Typography, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import video from "./video.mp4";
import { ArrowForward } from "@mui/icons-material";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { useMediaQuery } from "@mui/material";
import Header from "../Homepage/Components/Header"
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth,firestore } from "../../firebaseConfig"; // Import the Firebase auth module
import { doc, getDoc } from "firebase/firestore";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../../Components/ProtectedRoute/Loading";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

const ParternishipNews = () => {
  const [news, setNews] = useState([]);
  const [stockInfo, setStockInfo] = useState([]);
  const isMobile = useMediaQuery("(max-width:960px)"); // Adjust breakpoint as needed
  const navigate = useNavigate();
    const [user, setUser] = useState(null); // Store user details
    const [paiduser, setUserPaid] = useState(null); // Store Firestore name
     const [isLoading, setIsLoading] = useState(false); // Loading bar state
           const [expandedRowId, setExpandedRowId] = useState(null);
         const [performanceMap, setPerformanceMap] = useState({});
         const [showCloseLabel, setShowCloseLabel] = useState(false);

  useEffect(() => {
    fetchBestPerformingStocks(
      "https://my-market-data-bucket.s3.ap-southeast-2.amazonaws.com/market_data_US.json"
    );
    fetchStockData(
      "https://my-market-data-bucket.s3.ap-southeast-2.amazonaws.com/partnership.json"
    );
  }, []);


    useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
        if (currentUser) {
          setUser(currentUser); // Set Firebase auth user data
  
          // Fetch user details from Firestore
          const userDocRef = doc(firestore, "users", currentUser.uid);
          const userDoc = await getDoc(userDocRef);
  
          if (userDoc.exists()) {
            const userData = userDoc.data();
            if (userData.isPaidUserFlag) {
            setUserPaid(true);
            } // Set the name from Firestore
          }
        } else {
          setUser(null);
          setUserPaid(null);
        }
      });
  
      return () => unsubscribe(); // Cleanup the listener on unmount
    }, []);
  
    const handleSeePerformance = async (symbol, date, rowId) => {
      try {
        const formattedDate = new Date(date).toISOString().split("T")[0];
    
        const response = await axios.post("https://app.stock101.org/performance", {
          ticker: symbol,
          date: formattedDate,
        });
    
        const { initial_price, final_price, percentage_change, hourly_prices } = response.data;
    
        // Store performance data mapped to row ID
        setPerformanceMap((prev) => ({
          ...prev,
          [rowId]: {
            symbol,
            date: formattedDate,
            initial_price,
            final_price,
            percentage_change,
            hourly_prices,
          },
        }));
    
        // Set expanded row to show chart
        setExpandedRowId(rowId);
    
      } catch (error) {
        console.error("Error fetching performance:", error);
        alert("Failed to fetch performance data.");
      }
    };

     const ChartComponent = ({ data }) => {
            if (!data || data.length < 2) return null;
      
            const animationPerPoint = 300; // 50ms per point (tweak as needed)
            const totalDuration = data.length * animationPerPoint;
          
            const start = data[0];
            const end = data[data.length - 1];
            const isPositive = end.price >= start.price;
            const percentageChange = (((end.price - start.price) / start.price) * 100).toFixed(2);
          
            const lineColor = isPositive ? "#4caf50" : "#e53935";
            const bgColor = isPositive ? "rgba(76, 175, 80, 0.05)" : "rgba(229, 57, 53, 0.05)";
            const symbol = data[0].symbol || ""; // Optional if you include symbol in data
    
    
    
    
          
            return (
              <Box sx={{ position: "relative", backgroundColor: bgColor, p: 3, borderRadius: 2 }}>
                
                <ResponsiveContainer width="100%" height={230}>
                  <LineChart data={data} margin={{ top: 30, right: 20, left: 50, bottom: 10 }}>
          
                    {/* 🕰️ X-Axis with modern labels */}
                    <XAxis
                      dataKey="time"
                      tickFormatter={(value, index) => {
                        if (index === 0) {
                          const daysAgo = Math.round((new Date() - new Date(data[0].time)) / (1000 * 60 * 60 * 24));
                          return `${daysAgo} days ago`;
                        }
                        if (index === data.length - 1) return "Latest";
                        return "";
                      }}
                      tick={{ fontSize: 12, fill: "#888" }}
                      interval="preserveStartEnd"
                      axisLine={false}
                      tickLine={false}
                    />
          
                    {/* 💸 Hide Y-Axis */}
                    <YAxis hide domain={["dataMin", "dataMax"]} />
          
                    {/* ✨ Tooltip */}
                    <Tooltip
                      contentStyle={{
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        fontFamily: "'Work Sans', sans-serif",
                        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                        borderColor: lineColor,
                      }}
                      formatter={(value) => [`$${value}`, "Price"]}
                      labelFormatter={() => ""}
                    />
          
                    {/* 📈 Line with slowed animation */}
                    <Line
                      type="monotone"
                      dataKey="price"
                      stroke={lineColor}
                      strokeWidth={2.8}
                      dot={false}
                      isAnimationActive={true}
                      animationDuration={totalDuration}
                
                    />
          
                    {/* 💸 Overlay % Change Label */}
                    <foreignObject x="40%" y="10" width="120" height="40">
                      <Box
                        sx={{
                          backgroundColor: lineColor,
                          color: "#fff",
                          fontWeight: "bold",
                          borderRadius: "20px",
                          px: 2,
                          py: 0.5,
                          fontSize: "0.85rem",
                          textAlign: "center",
                          fontFamily: "'Work Sans', sans-serif",
                          boxShadow: `0 0 8px ${lineColor}`,
                        }}
                      >
                        {isPositive ? "▲" : "▼"} {percentageChange}%
                      </Box>
                    </foreignObject>
          
                    {/* 🏷️ Symbol + Open/Close Labels Inside Chart */}
                    <foreignObject x="2%" y="50%" width="120" height="40">
                    {!isMobile && (
                      <Typography
                        sx={{
                          fontSize: "0.95rem",
                          color: lineColor,
                          fontWeight: "bold",
                          fontFamily: "'Work Sans', sans-serif",
                        }}
                      >
                        {symbol && `${symbol} `}Open: ${start.price}
                      </Typography>
                    )}
                    </foreignObject>
          
                    <foreignObject x="calc(98% - 25%)" y="50%" width="120" height="40">
                    {!isMobile && (
          <Typography
            sx={{
              fontSize: "0.95rem",
              color: lineColor,
              fontWeight: "bold",
              fontFamily: "'Work Sans', sans-serif",
              textAlign: "right",
            }}
          >
            Close: ${end.price}
          </Typography>
        )}
        </foreignObject>
      
                  </LineChart>
                </ResponsiveContainer>
              </Box>
            );
          };






  const fetchBestPerformingStocks = (url) => {
    axios
      .get(url)
      .then((response) => {
        if (response.data) {
          setStockInfo(response.data.stock_info);
        }
      })
      .catch((error) => {
        console.error("Error fetching stock info:", error);
      });
  };

  const fetchStockData = async (url) => {
    setIsLoading(true); // Start loading
    try {
      const response = await axios.get(url);
      if (response.data) {
        const uniqueNewsSet = new Set();
        const filteredNews = response.data.filter((item) => {
          const uniqueKey = `${item.symbol}-${item.title}`;
          if (!uniqueNewsSet.has(uniqueKey)) {
            uniqueNewsSet.add(uniqueKey);
            return true;
          }
          return false;
        });

        const sortedNews = filteredNews.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setNews(sortedNews);
      }
    } catch (error) {
      console.error("Error fetching stock data:", error);
    } finally {
      setIsLoading(false); // End loading
  }
  };

  const findCompanyDetails = (symbol) => {
    const stock = stockInfo.find((stock) => stock.symbol === symbol);
    return stock
      ? {
          name: stock.company_name || "Unknown",
          website: stock.company_website || "",
        }
      : { name: "Unknown", website: "" };
  };

  const calculateTimeAgo = (dateString) => {
    const newsDate = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - newsDate) / 1000);

    if (diffInSeconds < 60) return `${diffInSeconds} seconds ago`;
    if (diffInSeconds < 3600)
      return `${Math.floor(diffInSeconds / 60)} minutes ago`;
    if (diffInSeconds < 86400)
      return `${Math.floor(diffInSeconds / 3600)} hours ago`;
    return `${Math.floor(diffInSeconds / 86400)} days ago`;
  };

  const columns = [
    {
      field: "symbol",
      headerName: "Symbol",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const { name, website } = findCompanyDetails(params.row.symbol);
        const websiteDomain = website
          .replace("https://", "")
          .replace("http://", "");
        const logoUrl = `https://img.logo.dev/${websiteDomain}?token=pk_ZEeufcgvTMe6FoAs8ob5hg&retina=true`;

        return (
          <div style={{ display: "flex", alignItems: isMobile ? "center" : "flex-start", flexDirection: isMobile ? "column" : "row", textAlign: isMobile ? "center" : "left" }}>
                                            <title>Stock101 Trending News</title>
                                <meta name="description" content="Welcome to stock 101 Trending News Page, Our Powerful AI engine allows users to view real time trending news updates, Analyst prize target updates,Buy Sell Hold Status Update, Market Capatalization, Call Options, Undervalues 
                                Stocks, Analyst Recommendations, Stock News, Search Stock News, Point based sporting based on technical indicatorsn, daily financial news" />
                                <meta name="keywords" content="NYSE, Stock Market, Option Based Filter,Zacks Rankings, Prize Targets, Trending News, Technical Indicators, Undervalued Stocks, Call Option Volume, Put Option Value" />
                                <meta name="robots" content="index, follow" /> 
            {/* Logo */}
            {website && (
              <img
                src={logoUrl}
                alt={`${params.row.symbol} logo`}
                style={{
                  height: "40px",
                  marginRight: "8px",
                  objectFit: "contain",
                  borderRadius: "4px",
                }}
              />
            )}
            {/* Symbol and Name */}
            <div>
              <div style={{ fontWeight: "bold" }}>{params.row.symbol}</div>
              <div style={{ fontSize: "0.8rem", color: "#555" }}>{name}</div>
            </div>
          </div>
        );
      },
    },
    {
      field: "rankingnews",
      headerName: "Trending News",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        const isExpanded = expandedRowId === params.row.id;
        const chartData = performanceMap[params.row.id];
    
        return (
          <div style={{ width: "100%" }}>
            <div style={{ textAlign: "left", marginBottom: "10px" }}>
              <a
                href={params.row.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: 600,
                  fontSize: "1rem",
                  fontFamily: "'Work Sans', sans-serif",
                  display: "block",
                }}
              >
                {params.row.title || "No Title"}
              </a>
              <a href={params.row.link}
              style={{textDecoration: "none"}}>
              <div
                style={{
                  color: "#666",
                  fontSize: "0.85rem",
                  fontFamily: "'Work Sans', sans-serif",
                  marginBottom: "6px",
                }}
              >
                                {isMobile
                  ? (params.row.description?.split(" ").slice(0, 30).join(" ") + "...")
                  : (params.row.description || "No description available.")
                }
              </div>
              </a>
              <div style={{ textAlign: "right" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => handleSeePerformance(params.row.symbol, params.row.date, params.row.id)}
                  sx={{
                    textTransform: "none",
                    fontSize: "0.75rem",
                    fontWeight: 500,
                    fontFamily: "'Work Sans', sans-serif",
                    padding: "2px 10px",
                  }}
                >
                  See Performance
                </Button>
              </div>
            </div>
    
            {isExpanded && chartData && (
              <Box sx={{ backgroundColor: "#f9f9f9", p: 2, mt: 1, borderRadius: 2, boxShadow: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
                  {chartData.symbol} — Open: ${chartData.initial_price} | Close: ${chartData.final_price} | Change: {chartData.percentage_change}%
                </Typography>
                <ChartComponent data={chartData.hourly_prices} />
              </Box>
            )}
          </div>
        );
      },
    },
    {
      field: "date",
      headerName: "Published",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <span
          style={{
            fontSize: "0.9rem",
            fontFamily: "'Work Sans', sans-serif",
            color: "#555",
          }}
        >
          {calculateTimeAgo(params.row.date)}
        </span>
      ),
    },
  ];

  const rows = news.map((item, index) => ({
    id: index,
    symbol: item.symbol,
    title: item.title || "N/A",
    description: item.summary || "N/A",
    date: item.date,
    link: item.link,
  }));


  const displayedRows = paiduser ? rows : rows.slice(0, 4); // Show only 5 rows for free users


  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        backgroundColor: "#f4f4f9",
        borderRadius: "0",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
      }}
    >
    <Header/>    

{!isMobile ? (
        // Mobile Layout
        
      <Grid container spacing={0} sx={{ height: "100%" }}>
        <Grid
          item
          xs={12}
          md={2}
          sx={{
            height: "100%",
            position: "relative",
          }}
        >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay with 50% opacity
                    }}
                  />
     {/* Text and Button Container */}
     <Box
        sx={{
          position: "absolute",
          top: { xs: "10%", sm: "20%" }, // Adjust based on screen size
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          color: "#fff",
          width: { xs: "90%", sm: "80%", md: "90%" }, // Constrain width
          maxWidth: "300px", // Prevent overflow on small screens
          padding: { xs: "10px", sm: "20px" },
          zIndex: 1,
        }}
      >
        
        {/* Heading */}
        <Typography
  variant="h2"
  sx={{
    fontSize: { xs: "16px", sm: "22px", md: "25px" }, // Responsive font size
    fontWeight: "bold",
    fontFamily: "'Work Sans', sans-serif",
    letterSpacing: "1px",
    color: "#fff",
    whiteSpace: "normal", // Allows text to wrap
    wordWrap: "break-word", // Breaks long words if needed
    textAlign: "center", // Aligns text properly
    overflow: "hidden",
    display: "block",
    lineHeight: "1.2", // Improves readability for multiline text
    maxWidth: "100%", // Ensures the text stays within the parent container
    padding: { xs: "5px", sm: "10px" }, // Adds padding for spacing
  }}
>
  Trending Related News
</Typography>

        {/* Button */}
        <Button
          variant="outlined"
          onClick={() => fetchStockData(
            "https://my-market-data-bucket.s3.ap-southeast-2.amazonaws.com/partnership.json"
          )}
          sx={{
            mt: 2, // Adjust margin
            fontSize: "14px", // Smaller font size for smaller screens
            fontWeight: "bold",
            fontFamily: "'Work Sans', sans-serif",
            letterSpacing: "1px",
            padding: "8px 16px",
            color: "#fff",
            borderColor: "#fff",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              borderColor: "#fff",
            },
          }}
        >
          Update News <AutorenewIcon />
        </Button>
      </Box>
          <video
            src={video}
            autoPlay
            loop
            playsInline
            muted
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "0px",
            }}
          />
          
        </Grid>
        <Grid
          item
          xs={12}
          md={10}
          sx={{
            height: "100%",
            paddingBottom: !paiduser ? "150px" : "77px", 
          }}
        >
                                  {isLoading ? (
  <LoadingScreen /> // Replace with your actual loading component
) : (
            
          <DataGrid
            rows={displayedRows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5, 10, 20]}
            getRowHeight={() => "auto"}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#1e88e5",
                color: "black",
                fontWeight: 600,
                fontSize: "1rem",
                fontFamily: "'Work Sans', sans-serif",
                textTransform: "uppercase",
                borderBottom: "2px solid #ddd",
              },
              "& .MuiDataGrid-cell": {
                fontSize: "0.9rem",
                fontFamily: "'Work Sans', sans-serif",
                color: "#333",
                borderBottom: "1px solid #f0f0f0",
                padding: "8px",
              },
              "& .MuiDataGrid-footerContainer": {
                backgroundColor: "#f9f9f9",
                fontFamily: "'Work Sans', sans-serif",
                fontSize: "0.9rem",
                fontWeight: 500,
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#e3f2fd",
                cursor: "pointer",
              },
              height: "100%",
            }}
          />
)}
              {!paiduser && (
                <>
                  {/* Subscribe Button */}
                  <Box
                    sx={{
                      textAlign: "center",
                      padding: "16px",
                      
                      backgroundColor: "#f0f0f0",
                      borderRadius: "10px",
                      
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{
                        textTransform: "none",
                        fontSize: 16,
                        fontFamily: "'Work Sans', sans-serif",
                        borderRadius: "20px",
                        padding: "8px 24px",
                      }}
                      onClick={() => {
                        navigate("/ManageSubscription");
                      }}
                    >
                      Subscribe to view all
                    </Button>
                  </Box>
                </>
              )}
        </Grid>
      </Grid>
):(
<Box
  sx={{
    height: "100vh",
    width: "100%",
    backgroundColor: "#f4f4f9",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column", // Stack video and DataGrid vertically
  }}
>
  {/* Video Section */}
  <Box
    sx={{
      height: "20vh", // Video takes 20% of the screen height
      position: "relative",
    }}
  >
    {/* Dark Overlay */}
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1,
      }}
    />
    {/* Text and Button */}
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        color: "#fff",
        zIndex: 2,
        padding: "10px",
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontSize: "16px",
          fontWeight: "bold",
          fontFamily: "'Work Sans', sans-serif",
          letterSpacing: "1px",
          color: "#fff",
          whiteSpace: "normal",
        }}
      >
        Trending Related News
      </Typography>
      <Button
        variant="outlined"
        onClick={() => fetchStockData(
            "https://my-market-data-bucket.s3.ap-southeast-2.amazonaws.com/partnership.json"
          )}
        sx={{
          mt: 2,
          fontSize: "12px",
          fontWeight: "bold",
          color: "#fff",
          borderColor: "#fff",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          },
        }}
      >
        Update News <AutorenewIcon />
      </Button>
    </Box>
    {/* Video Background */}
    <video
      src={video}
      autoPlay
      loop
      playsInline
      muted
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
  </Box>

  {/* DataGrid Section */}
  <Box
    sx={{
      flex: 1, // Takes the remaining space below the video
      width: "100%",
      overflow: "hidden",
    }}
  >
                  {!paiduser && (
                <>
                  {/* Subscribe Button */}
                  <Box
                    sx={{
                      textAlign: "center",
                      padding: "16px",
                      
                      backgroundColor: "#f0f0f0",
                      borderRadius: "10px",
                      
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{
                        textTransform: "none",
                        fontSize: 16,
                        fontFamily: "'Work Sans', sans-serif",
                        borderRadius: "20px",
                        padding: "8px 24px",
                      }}
                      onClick={() => {
                        navigate("/ManageSubscription");
                      }}
                    >
                      Subscribe to view all
                    </Button>
                  </Box>
                </>
              )}
                                      {isLoading ? (
  <LoadingScreen /> // Replace with your actual loading component
) : (
           <DataGrid
            rows={displayedRows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5, 10, 20]}
            getRowHeight={() => "auto"}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#1e88e5",
                color: "black",
                fontWeight: 600,
                fontSize: "1rem",
                fontFamily: "'Work Sans', sans-serif",
                textTransform: "uppercase",
                borderBottom: "2px solid #ddd",
              },
              "& .MuiDataGrid-cell": {
                fontSize: "0.9rem",
                fontFamily: "'Work Sans', sans-serif",
                color: "#333",
                borderBottom: "1px solid #f0f0f0",
                padding: "8px",
              
                
              },
              "& .MuiDataGrid-footerContainer": {
                backgroundColor: "#f9f9f9",
                fontFamily: "'Work Sans', sans-serif",
                fontSize: "0.9rem",
                fontWeight: 500,
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#e3f2fd",
                cursor: "pointer",
              },
              height: "100%",paddingBottom: paiduser ? "77px" : "150px",
            }}
          />
)}
  </Box>
</Box>
)}
    </Box>
  );
};

export default ParternishipNews;
